// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root___GUZ9"};